export const CTA_DISPLAY_PHONE_NUMBER = '(866) 953-0189';
export const CTA_PHONE_NUMBER = '+18669530189';
